import React from 'react';
import { Route } from 'react-router-dom';
import Employeecard from '../../Employeedata/Employeecard.js';
import TicketForm from '../../Employeedata/EmployeeFiles/EnterTicketForm.js';
import EmployeeList from '../../Employeedata/EmployeeFiles/EmployeeTicketsList.js';
import EmployeeDataAllList from '../../Employeedata/EmployeeFiles/EmployeeDataAllList.js';
import SOP from '../../Employeedata/EmployeeFiles/SOP-data.js';
import SOPPOST from '../../Employeedata/EmployeeFiles/SOP-post.js';
import Employeedaterange from '../../Employeedata/EmployeeFiles/Employedatedaterange.js';
import LeaveCard from '../../Leave-data/leavecard.js';
import Applyleave from '../../Leave-data/Leave-data-files/Leave-Post.js';
import Getleavedata from '../../Leave-data/Leave-data-files/leavaedata-get.js';
import LeaveStatus from '../../Leave-data/Leave-data-files/Leave-status.js';

export const employeeLeaveRoutes = [
  <Route key="employeecard" path="/Employeecard" element={<Employeecard />} />,
  <Route key="ticket-form" path="/TicketForm" element={<TicketForm />} />,
  <Route key="employee-list" path="/EmployeeList" element={<EmployeeList />} />,
  <Route key="employee-data-all" path="/employee-data/all" element={<EmployeeDataAllList />} />,
  <Route key="sop" path="/SOP" element={<SOP />} />,
  <Route key="sop-post" path="/SOP-POST" element={<SOPPOST />} />,
  <Route key="employee-date-range" path="/EmployeeDateRange" element={<Employeedaterange />} />,
  <Route key="leave-card" path="/LeaveCard" element={<LeaveCard />} />,
  <Route key="apply-leave" path="/Applyleave" element={<Applyleave />} />,
  <Route key="get-leave-data" path="/Getleavedata" element={<Getleavedata />} />,
  <Route key="leave-status" path="/LeaveStatus" element={<LeaveStatus />} />,
];
